(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    class CustomProductGallery {
      constructor(root) {
        this.root = root;
        this.slides = Array.from(root.querySelectorAll('[data-cpg-slide]'));
        this.thumbs = Array.from(root.querySelectorAll('[data-cpg-thumb]'));
        this.ticks = Array.from(root.querySelectorAll('[data-cpg-tick]'));
        this.prevBtns = Array.from(root.querySelectorAll('[data-cpg-prev]'));
        this.nextBtns = Array.from(root.querySelectorAll('[data-cpg-next]'));
        this.numberCurrent = root.querySelector('[data-cpg-number-current]');
        this.stage = root.querySelector('[data-cpg-stage]');
        this.zoomModal = null;
        this.zoomEnabled = root.dataset.zoomEnabled === 'true';
        this.zoomLens = root.querySelector('[data-cpg-zoom-lens]');
        this._hoverZoomActive = false;
        this._hoverZoomSrc = '';
        this._desktopZoomMq = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
        this._onHoverZoomMove = this._onHoverZoomMove.bind(this);
        this._onHoverZoomLeave = this._onHoverZoomLeave.bind(this);
        this._onHoverZoomScroll = this._onHoverZoomScroll.bind(this);

        this.currentIndex = 0;
        this.total = this.slides.length;

        this.autoplay = root.dataset.autoplay === 'true';
        this.autoplayInterval = parseInt(root.dataset.autoplayInterval, 10) || 5000;
        this.autoplayTimer = null;

        // JS 强制修复祖先元素的 overflow 遮挡
        this._fixStickyParents();

        // 为性能,缓存 thumb 按 index 分组
        this.thumbsByIndex = {};
        this.thumbs.forEach((t) => {
          const idx = parseInt(t.dataset.index, 10);
          if (!this.thumbsByIndex[idx]) this.thumbsByIndex[idx] = [];
          this.thumbsByIndex[idx].push(t);
        });

        this.bindVideoControls();
        this.bindExternalVideos();
        this.bindZoom();

        if (this.total <= 1) return;

        this.bindNavButtons();
        this.bindThumbs();
        this.bindTicks();
        this.bindTouch();

        // 非关键绑定延后
        this._deferNonCritical();
      }

      _fixStickyParents() {
        const wrapper = this.root;
        // 如果未开启 sticky 或在移动端，则跳过
        if (!wrapper.classList.contains('cpg-wrapper--sticky') || window.innerWidth < 750) return;

        // 向上递归解锁主题自带的 overflow: hidden 限制 (它是 sticky 失效的最大元凶)
        let parent = wrapper.parentElement;
        let depth = 0;
        // 最多向上寻找 8 层
        while (parent && parent.tagName !== 'BODY' && depth < 8) {
          const style = window.getComputedStyle(parent);
          if (style.overflow === 'hidden' || style.overflowY === 'hidden' || style.overflow === 'clip') {
             // 强制放开限制
             parent.style.setProperty('overflow', 'visible', 'important');
          }
          parent = parent.parentElement;
          depth++;
        }
      }

      _deferNonCritical() {
        const run = () => {
          this.bindKeyboard();
          if (this.autoplay) {
            this.startAutoplay();
            this.stage.addEventListener('mouseenter', () => this.stopAutoplay());
            this.stage.addEventListener('mouseleave', () => this.startAutoplay());
          }
          // 预加载相邻图片
          this._preloadAdjacent(0);
        };
        if ('requestIdleCallback' in window) {
          requestIdleCallback(run, { timeout: 1500 });
        } else {
          setTimeout(run, 800);
        }
      }

      _preloadAdjacent(currentIdx) {
        const next = (currentIdx + 1) % this.total;
        const nextSlide = this.slides[next];
        if (!nextSlide) return;
        const img = nextSlide.querySelector('img');
        if (img && img.loading === 'lazy') {
          img.loading = 'eager';
          if ('fetchPriority' in img) img.fetchPriority = 'low';
        }
      }

      bindNavButtons() {
        this.prevBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.go(this.currentIndex - 1);
            this.resetAutoplay();
          });
        });
        this.nextBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.go(this.currentIndex + 1);
            this.resetAutoplay();
          });
        });
      }

      bindThumbs() {
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', (e) => {
            e.stopPropagation();
            const idx = parseInt(thumb.dataset.index, 10);
            this.go(idx);
            this.resetAutoplay();
          });
          thumb.addEventListener('mouseenter', () => {
            if (window.matchMedia('(hover: hover)').matches) {
              const idx = parseInt(thumb.dataset.index, 10);
              this.go(idx);
            }
          });
        });
      }

      bindTicks() {
        this.ticks.forEach((tick) => {
          tick.addEventListener('click', (e) => {
            e.stopPropagation();
            const idx = parseInt(tick.dataset.index, 10);
            this.go(idx);
            this.resetAutoplay();
          });
        });
      }

      bindVideoControls() {
        this.slides.forEach((slide) => {
          if (slide.dataset.type !== 'video') return;
          const video = slide.querySelector('[data-cpg-video]');
          // 角标按钮 + 封面正中的大播放按钮,都走同一套播放/暂停
          const toggles = slide.querySelectorAll('[data-cpg-video-toggle]');
          if (!video || !toggles.length) return;

          video.muted = true;

          toggles.forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
              e.stopPropagation();
              if (video.paused) {
                video.play().catch(() => {});
                this.stopAutoplay();
              } else {
                video.pause();
              }
            });
          });

          const controls = slide.querySelector('[data-cpg-video-controls]');
          const setPlaying = (playing) => {
            toggles.forEach((t) => t.classList.toggle('is-playing', playing));
            if (controls) controls.classList.toggle('is-playing', playing);
            if (playing) slide.classList.add('is-video-playing');
          };

          video.addEventListener('ended', () => setPlaying(false));
          video.addEventListener('pause', () => setPlaying(false));
          video.addEventListener('play', () => setPlaying(true));

          slide.querySelectorAll('[data-cpg-video-seek]').forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.stopPropagation();
              const delta = parseInt(btn.dataset.cpgVideoSeek, 10) || 0;
              const apply = () => {
                const duration = Number.isFinite(video.duration) ? video.duration : video.currentTime + Math.abs(delta);
                video.currentTime = Math.min(Math.max(0, (video.currentTime || 0) + delta), duration);
              };
              if (video.readyState >= 1) {
                apply();
              } else {
                video.preload = 'metadata';
                video.addEventListener('loadedmetadata', apply, { once: true });
                video.load();
              }
            });
          });

          const soundToggle = slide.querySelector('[data-cpg-video-sound]');
          if (soundToggle) {
            const updateSoundToggle = () => {
              const soundOn = !video.muted;
              soundToggle.classList.toggle('is-sound-on', soundOn);
              soundToggle.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
              soundToggle.setAttribute('aria-label', soundOn ? 'Mute sound' : 'Turn sound on');
            };

            soundToggle.addEventListener('pointerdown', (e) => {
              e.stopPropagation();
              this.hideHoverZoom();
            });

            soundToggle.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.hideHoverZoom();
              video.muted = !video.muted;
              if (!video.muted) video.volume = 1;
              updateSoundToggle();
            });

            video.addEventListener('volumechange', updateSoundToggle);
            updateSoundToggle();
          }
        });
      }

      bindExternalVideos() {
        this.slides.forEach((slide) => {
          if (slide.dataset.type !== 'external_video') return;
          const playBtn = slide.querySelector('[data-cpg-external-play]');
          const placeholder = slide.querySelector('[data-cpg-external-placeholder]');
          if (!playBtn || !placeholder) return;

          playBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const host = slide.dataset.host;
            const id = slide.dataset.externalId;
            let src = '';
            if (host === 'youtube') {
              src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
            } else if (host === 'vimeo') {
              src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
            }
            if (!src) return;

            const iframe = document.createElement('iframe');
            iframe.src = src;
            iframe.allow = 'autoplay; encrypted-media; fullscreen';
            iframe.allowFullscreen = true;
            iframe.style.cssText = 'width:100%;height:100%;border:0;position:absolute;inset:0;';
            placeholder.innerHTML = '';
            placeholder.appendChild(iframe);
            this.stopAutoplay();
          });
        });
      }

      bindZoom() {
        if (!this.stage || !this.zoomEnabled) return;

        this.bindHoverZoom();

        this.stage.addEventListener('click', (e) => {
          if (this._isDesktopHoverZoom()) return;

          const blockedTarget = e.target.closest(
            'button, a, iframe, video, .cpg-video-toggle, .cpg-video-controls, .cpg-video-sound, .cpg-media-dock, .cpg-nav, .cpg-click-zone, .cpg-thumb'
          );

          if (blockedTarget) return;

          const activeSlide = this.slides[this.currentIndex];
          if (!activeSlide || activeSlide.dataset.type !== 'image') return;

          const img = activeSlide.querySelector('.cpg-media--image');
          if (!img) return;

          this.openZoom(img);
        });
      }

      _isDesktopHoverZoom() {
        return this._desktopZoomMq.matches;
      }

      bindHoverZoom() {
        if (!this.stage || !this.zoomLens) return;

        this.stage.addEventListener('mousemove', this._onHoverZoomMove);
        this.stage.addEventListener('mouseleave', this._onHoverZoomLeave);
        window.addEventListener('scroll', this._onHoverZoomScroll, { passive: true });
        window.addEventListener('resize', this._onHoverZoomScroll, { passive: true });
      }

      _onHoverZoomScroll() {
        if (this._hoverZoomActive) this.hideHoverZoom();
      }

      _onHoverZoomLeave() {
        this.hideHoverZoom();
      }

      _onHoverZoomMove(e) {
        if (!this._isDesktopHoverZoom()) {
          this.hideHoverZoom();
          return;
        }

        const blocked = e.target.closest(
          'button, a, iframe, video, .cpg-video-toggle, .cpg-video-controls, .cpg-video-sound, .cpg-media-dock, .cpg-nav, .cpg-click-zone, .cpg-thumb, .cpg-ticks, [data-cpg-video-slot]'
        );
        if (blocked) {
          this.hideHoverZoom();
          return;
        }

        const activeSlide = this.slides[this.currentIndex];
        if (!activeSlide || activeSlide.dataset.type !== 'image') {
          this.hideHoverZoom();
          return;
        }

        const img = activeSlide.querySelector('.cpg-media--image');
        if (!img) {
          this.hideHoverZoom();
          return;
        }

        this.updateHoverZoom(e, img);
      }

      updateHoverZoom(e, img) {
        const stageRect = this.stage.getBoundingClientRect();
        if (stageRect.width < 40 || stageRect.height < 40) return;

        const scale = parseFloat(this.root.style.getPropertyValue('--cpg-zoom-scale-desktop').trim()) || 3;
        const zoomSrc = img.dataset.cpgZoomSrc || img.currentSrc || img.src;
        if (!zoomSrc) return;

        if (this._hoverZoomSrc !== zoomSrc) {
          this._hoverZoomSrc = zoomSrc;
          this.zoomLens.style.backgroundImage = `url("${zoomSrc}")`;
          const preload = new Image();
          preload.src = zoomSrc;
        }

        const loupeSize = Math.min(
          230,
          Math.max(140, Math.min(stageRect.width, stageRect.height) * 0.5)
        );
        const x = e.clientX - stageRect.left;
        const y = e.clientY - stageRect.top;

        let lensLeft = x - loupeSize / 2;
        let lensTop = y - loupeSize / 2;
        lensLeft = Math.min(Math.max(lensLeft, 0), stageRect.width - loupeSize);
        lensTop = Math.min(Math.max(lensTop, 0), stageRect.height - loupeSize);

        const cx = Math.min(Math.max(x, 0), stageRect.width);
        const cy = Math.min(Math.max(y, 0), stageRect.height);
        const bgW = stageRect.width * scale;
        const bgH = stageRect.height * scale;
        const bgX = -(cx * scale - loupeSize / 2);
        const bgY = -(cy * scale - loupeSize / 2);

        this.zoomLens.style.width = `${loupeSize}px`;
        this.zoomLens.style.height = `${loupeSize}px`;
        this.zoomLens.style.transform = `translate(${lensLeft}px, ${lensTop}px)`;
        this.zoomLens.style.backgroundSize = `${bgW}px ${bgH}px`;
        this.zoomLens.style.backgroundPosition = `${bgX}px ${bgY}px`;
        this.zoomLens.hidden = false;
        this.zoomLens.classList.add('is-visible');
        this.zoomLens.setAttribute('aria-hidden', 'false');
        this._hoverZoomActive = true;
      }

      hideHoverZoom() {
        if (!this._hoverZoomActive && !(this.zoomLens && this.zoomLens.classList.contains('is-visible'))) {
          return;
        }

        this._hoverZoomActive = false;

        if (this.zoomLens) {
          this.zoomLens.classList.remove('is-visible');
          this.zoomLens.hidden = true;
          this.zoomLens.setAttribute('aria-hidden', 'true');
        }
      }

      openZoom(sourceImg) {
        const zoomSrc = sourceImg.dataset.cpgZoomSrc || sourceImg.currentSrc || sourceImg.src;
        if (!zoomSrc) return;

        this.ensureZoomModal();

        const modalImg = this.zoomModal.querySelector('[data-cpg-zoom-img]');
        modalImg.src = zoomSrc;
        modalImg.alt = sourceImg.alt || '';
        modalImg.style.transformOrigin = '50% 50%';

        const desktopScale = this.root.style.getPropertyValue('--cpg-zoom-scale-desktop').trim() || '3';
        const mobileScale = this.root.style.getPropertyValue('--cpg-zoom-scale-mobile').trim() || '1.65';
        this.zoomModal.style.setProperty('--cpg-modal-zoom-scale', desktopScale);
        this.zoomModal.style.setProperty('--cpg-modal-zoom-scale-mobile', mobileScale);

        this.zoomModal.classList.add('is-open');
        this.zoomModal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cpg-zoom-lock');
      }

      ensureZoomModal() {
        let modal = document.querySelector('[data-cpg-zoom-modal]');

        if (!modal) {
          modal = document.createElement('div');
          modal.className = 'cpg-zoom-modal';
          modal.setAttribute('data-cpg-zoom-modal', '');
          modal.setAttribute('aria-hidden', 'true');

          modal.innerHTML = `
            <button type="button" class="cpg-zoom-modal__close" data-cpg-zoom-close aria-label="Close image zoom">×</button>
            <div class="cpg-zoom-modal__viewport" data-cpg-zoom-viewport>
              <img class="cpg-zoom-modal__img" data-cpg-zoom-img alt="">
            </div>
            <div class="cpg-zoom-modal__hint">Drag to inspect details · Tap to close</div>
          `;

          document.body.appendChild(modal);

          const closeZoom = () => {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('cpg-zoom-lock');
          };

          const viewport = modal.querySelector('[data-cpg-zoom-viewport]');
          const modalImg = modal.querySelector('[data-cpg-zoom-img]');
          const closeBtn = modal.querySelector('[data-cpg-zoom-close]');

          closeBtn.addEventListener('click', closeZoom);
          viewport.addEventListener('click', closeZoom);

          viewport.addEventListener('mousemove', (e) => {
            const rect = viewport.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;

            modalImg.style.transformOrigin = `${x}% ${y}%`;
          });

          viewport.addEventListener('touchmove', (e) => {
            if (!e.touches || !e.touches.length) return;
            const touch = e.touches[0];
            const rect = viewport.getBoundingClientRect();
            const x = ((touch.clientX - rect.left) / rect.width) * 100;
            const y = ((touch.clientY - rect.top) / rect.height) * 100;

            modalImg.style.transformOrigin = `${x}% ${y}%`;
          }, { passive: true });

          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('is-open')) {
              closeZoom();
            }
          });
        }

        this.zoomModal = modal;
      }

      bindKeyboard() {
        this.root.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.currentIndex - 1); this.resetAutoplay(); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.currentIndex + 1); this.resetAutoplay(); }
        });
        if (!this.root.hasAttribute('tabindex')) this.root.setAttribute('tabindex', '0');
      }

      bindTouch() {
        let startX = 0, startY = 0, isTracking = false;
        const threshold = 50;

        this.stage.addEventListener('touchstart', (e) => {
          if (e.touches.length !== 1) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          isTracking = true;
          this.stopAutoplay();
        }, { passive: true });

        this.stage.addEventListener('touchend', (e) => {
          if (!isTracking) return;
          isTracking = false;
          const endX = e.changedTouches[0].clientX;
          const endY = e.changedTouches[0].clientY;
          const dx = endX - startX;
          const dy = endY - startY;

          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > threshold) {
            if (dx > 0) this.go(this.currentIndex - 1);
            else this.go(this.currentIndex + 1);
          }

          if (this.autoplay) this.startAutoplay();
        }, { passive: true });
      }

      startAutoplay() {
        if (!this.autoplay || this.total <= 1) return;
        this.stopAutoplay();
        this.autoplayTimer = setInterval(() => {
          this.go(this.currentIndex + 1);
        }, this.autoplayInterval);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      resetAutoplay() {
        if (this.autoplay) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      go(target) {
        let next = target;
        if (next < 0) next = this.total - 1;
        if (next >= this.total) next = 0;
        if (next === this.currentIndex) return;

        this.hideHoverZoom();

        // 【关键修复位置】：缓存原先的索引，避免提前覆盖
        const prevIndex = this.currentIndex;

        // 暂停当前视频,并复位回封面图:再切回来时显示的是封面,不是暂停帧
        const currentSlide = this.slides[prevIndex];
        if (currentSlide && currentSlide.dataset.type === 'video') {
          const v = currentSlide.querySelector('[data-cpg-video]');
          if (v) {
            if (!v.paused) v.pause();
            try { v.currentTime = 0; } catch (err) {}
          }
          currentSlide.classList.remove('is-video-playing');
        }

        // 使用 requestAnimationFrame 批量更新 DOM
        requestAnimationFrame(() => {
          this.slides[prevIndex].classList.remove('is-active');
          this.slides[prevIndex].setAttribute('aria-hidden', 'true');
          this.slides[next].classList.add('is-active');
          this.slides[next].setAttribute('aria-hidden', 'false');

          if (this.thumbsByIndex[prevIndex]) {
            this.thumbsByIndex[prevIndex].forEach((t) => t.classList.remove('is-active'));
          }
          if (this.thumbsByIndex[next]) {
            this.thumbsByIndex[next].forEach((t) => {
              t.classList.add('is-active');
              // 如果是外部缩略图且不可见，自动平滑滚动将其带入视野
              if (t.classList.contains('cpg-thumb--external')) {
                t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
              }
            });
          }

          if (this.ticks.length) {
            this.ticks[prevIndex].classList.remove('is-active');
            this.ticks[next].classList.add('is-active');
          }

          if (this.numberCurrent) {
            this.numberCurrent.classList.add('is-switching');
            setTimeout(() => {
              const num = next + 1;
              this.numberCurrent.textContent = (num < 10 ? '0' : '') + num;
              this.numberCurrent.classList.remove('is-switching');
            }, 150);
          }
        });

        this.currentIndex = next;
        this._preloadAdjacent(next);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-cpg-root]').forEach((root) => {
        if (root.dataset.cpgInitialized === '1') return;
        root.dataset.cpgInitialized = '1';
        new CustomProductGallery(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
